

































import { Vue, Component, Ref } from 'vue-property-decorator'
import LayerWrapper from '@/orrm/wrapper/layer'
import { Layer } from '@/orrm/model/layer'
import { WMSCapabilities } from 'ol/format'
import LayerSelectorTree from '@/components/LayerSelectorTree.vue'
@Component({
  components: { LayerSelectorTree }
})
export default class AddLayerFluxForm extends Vue {
  fluxValid = false
  flux = ''
  loadingCapabilities = false
  capabilities: WMSCapabilities = new WMSCapabilities()
  selectedLayer: any[] = []
  layer: Layer | null = null

  urlRule = (v?: string) => {
    if (v && /https:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/.test(v)) {
      return true
    }
    return 'Veuillez saisir un lien HTTPS valide'
  }

  requiredRule = (v?: string) => !!v || 'Ce champ est requis'

  @Ref()
  fluxForm: any

  @Ref()
  layersForm: any

  get globalLayer () {
    const capabilities = this.capabilities as any
    return capabilities.Capability?.Layer
  }

  get fluxLayers (): any[] {
    return this.globalLayer?.Layer || []
  }

  async validateFlux () {
    if (this.fluxForm.validate()) {
      this.selectedLayer = []
      this.capabilities = new WMSCapabilities()
      this.layer = Layer.createLayer({
        title: '',
        field_orrm_flux: { value: this.flux } // eslint-disable-line
      }, this.generateGuid(), 'WMS')

      try {
        this.loadingCapabilities = true
        this.capabilities = await this.layer.getCapabilities() as WMSCapabilities
      } finally {
        this.loadingCapabilities = false
      }
    }
  }

  updateQueryStringParameter (uri: string, key: string, value: string) {
    const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
    const separator = uri.indexOf('?') !== -1 ? '&' : '?'
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + '=' + value + '$2')
    } else {
      return uri + separator + key + '=' + value
    }
  }

  validateLayers () {
    if (!this.layer) return
    for (const selectedLayer of this.selectedLayer) {
      const updatedFlux = this.updateQueryStringParameter(this.layer.flux.value || '', 'layers', selectedLayer.Name)

      const layer: Layer = Layer.createLayer({
        title: selectedLayer.Title || '',
        field_orrm_flux: { value: updatedFlux } // eslint-disable-line
      }, this.generateGuid(), 'WMS')
      this.$emit('add:layer', new LayerWrapper(layer))
    }
  }

  generateGuid () {
    let result = ''
    for (let j = 0; j < 32; j++) {
      if (j === 8 || j === 12 || j === 16 || j === 20) result = result + '-'
      result += Math.floor(Math.random() * 16).toString(16).toUpperCase()
    }
    return result
  }
}
